﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const form_controls_1 = require("@its-suite/form-controls");
class BaseSettingsConversion {
    static getStringValue(items, key, defaultValue) {
        let value = defaultValue;
        let item = this.findItem(items, key);
        if (item) {
            value = item.value;
        }
        return value;
    }
    static getNumberValue(items, key, defaultValue) {
        let value = defaultValue;
        let item = this.findItem(items, key);
        if (item) {
            value = (form_controls_1.StringHelpers.getNumber(item.value));
        }
        return value;
    }
    static getBooleanValue(items, key, defaultValue) {
        let value = defaultValue;
        let item = this.findItem(items, key);
        if (item) {
            value = (item.value.trim().toLocaleLowerCase() === 'true');
        }
        return value;
    }
    static getEnumValue(items, key, defaultValue) {
        let value = defaultValue;
        let item = this.findItem(items, key);
        if (item) {
            value = item.value;
        }
        return value;
    }
    static findItem(items, key) {
        return items.find(si => si.key.toUpperCase() === key.toUpperCase());
    }
}
exports.BaseSettingsConversion = BaseSettingsConversion;
//# sourceMappingURL=BaseSettingsConversion.js.map